module.exports = __webpack_public_path__ + "img/i5.a18ce4a7.png";